import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { DatetimeString } from '#/types/TypedDateString';

const formatterOptions = { numeric: 'always', style: 'long' } as const;
const formatters = {
  [I18nLocale.EN]: new Intl.RelativeTimeFormat('en', formatterOptions),
  [I18nLocale.ES]: new Intl.RelativeTimeFormat('es', formatterOptions),
  [I18nLocale.PT]: new Intl.RelativeTimeFormat('pt', formatterOptions),
} as const;

export function timeago(
  date: DatetimeString,
  { locale, now }: { locale: I18nLocale; now: DatetimeString },
) {
  const diffMs = new Date(date).getTime() - new Date(now).getTime();
  const formatter = formatters[locale];

  const seconds = Math.round(diffMs / 1000);
  if (Math.abs(seconds) < 60) return formatter.format(seconds, 'second');

  const minutes = Math.round(seconds / 60);
  if (Math.abs(minutes) < 60) return formatter.format(minutes, 'minute');

  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return formatter.format(hours, 'hour');

  const days = Math.round(hours / 24);
  if (Math.abs(days) < 30) return formatter.format(days, 'day');

  const months = Math.round(days / 30);
  if (Math.abs(months) < 12) return formatter.format(months, 'month');

  const years = Math.round(days / 365);
  return formatter.format(years, 'year');
}
